import { ForgotPasswordPage } from "../components"

export default ForgotPasswordPage
